module.exports = __webpack_public_path__ + "img/logo.0c8ff802.svg";